import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noRequestTypeOptionDescription: {
		id: 'issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description',
		defaultMessage: 'Issues can’t be shared with customers, and may not work as expected.',
		description:
			'Description text for the "No request type" option in the request type selection of an issue create form',
	},
	ariaLabel: {
		id: 'issue-create.modal.create-form.type-picker.request-type-select.aria-label',
		defaultMessage: 'Select request type',
		description: 'Aria label for request type field',
	},
	noRequestTypeOptionDescriptionIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description-issue-term-refresh',
		defaultMessage: 'Work items can’t be shared with customers, and may not work as expected.',
		description:
			'Description text for the "No request type" option in the request type selection of an issue create form',
	},
});
